import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/monitores/monitor";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    errors: [],
    logs: [],
    status: [],
    quantities: [],
    config: [],
    dayStart: null,
    dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000),
  },
  mutations: {
    setDateFrom(state, data) {
      state.dateFrom = data;
    },
    setErrors(state, data) {
      state.errors = data;
    },
    setLogs(state, data) {
      state.logs = data;
    },
    SetStatus(state, data) {
      state.status = data;
    },
    setQuantities(state, data) {
      state.quantities = data;
    },
    setConfig(state, data) {
      state.config = data;
    },
    setDayStart(state, data) {
      state.dayStart = data;
    },
  },
  actions: {
    async getErrors(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getErrors();

          state.commit("setErrors", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getLogs(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLogs();
          state.commit("setLogs", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getStatus(state, periodo) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getStatus(periodo);
          state.commit("SetStatus", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getQuantities(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getQuantities();
          state.commit("setQuantities", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getConfig(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getConfig();
          state.commit("setConfig", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async activate(state, item) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.activate(item).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async startDate(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.startDate(state.state.dayStart).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
